import { Center, Loader } from '@mantine/core';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/stores/authContext';
import { useIsAgent } from '@/hooks/useRoles';
import { ROUTES } from '@/routes/paths';

// Роут-гард: раздел НЕ для агента (аккредитация, агентский договор, API-доступ — агенту не нужны).
// Стоит внутри RequireAuth. Агент уводится на указанный раздел (по умолчанию «Главное»). Страховка от
// прямого захода по URL: в интерфейсе эти пункты агенту и так не показываются.
export default function RequireNonAgent({ redirectTo = ROUTES.APP }: { readonly redirectTo?: string }) {
  const { isInitializing } = useAuth();
  const isAgent = useIsAgent();

  if (isInitializing) {
    return (
      <Center h="50vh">
        <Loader />
      </Center>
    );
  }
  return isAgent ? <Navigate to={redirectTo} replace /> : <Outlet />;
}
